import React, {Component} from 'react';
import {Link} from "react-router-dom";
import SearchComponent from "../../shared/search/components/SearchComponent";
import SegmentService from '../../../data/pages/segments/SegmentService';
import LightBoxComponent from "../../shared/lightbox/components/LightBoxComponent";
import LoginComponent from "../../shared/Login/components/LoginComponent";

import "../style/MenuStyle.scss";
import AuthenticationService from '../../../services/AuthenticationService';

const RenderLightBox = props => {

    const {show, handleClick} = props;

    return (
        <LightBoxComponent isOpen={show} handleClick={handleClick} handleEventClose={handleClick}>
            <LoginComponent/>
        </LightBoxComponent>
    );
};


class MenuComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            segments: [],
            showLightBox: false,
            loading: true
        }
    }

    showLightBox() {
        this.setState({
            showLightBox: true
        });
    }

    closeLightBox() {
        this.setState({
            showLightBox: false
        });
    }

    async componentDidMount() {
        let segmentService = new SegmentService();
        let segments = await segmentService.get();
        this.setState({segments: segments.results, loading: false});
    }

    active(ev) {
        if (document.getElementsByClassName("active")[0] !== undefined) {
            document.getElementsByClassName("active")[0].classList.remove("active")
        }
        ev.target.closest("li").classList.add("active");
    }

    handleClick(endPoint, ev) {
        this.active(ev);
        this.props.handleClick();
        this.props.getProducts(endPoint);
    }

    closeMenuMobile() {
        let menu = document.getElementById("navItems");
        menu.style.display = 'none';
    }

    static isLogged() {
        return window.localStorage.getItem("user") === null;
    }

    render() {
        return (
            <nav id="navItems">
                <div id="closeMenu" onClick={() => this.closeMenuMobile()}>x</div>
                <div className="centerNav">
                    {this.state.loading ? (
                        <ul>
                            <li>
                                BRANDS A-Z
                            </li>

                            <li>
                                WOMEN
                            </li>

                            <li>
                                MEN
                            </li>

                            <li>
                                KIDS
                            </li>

                            <li>
                                HOMEWEAR
                            </li>

                        </ul>
                    ) : window.localStorage.getItem("user_type") !== "buyer" ?(
                        <ul className="mnSeller">
                            <li>
                                <Link to={`/${window.localStorage.getItem('seller_slug')}`}>THE BRAND</Link>
                            </li>
                            <li>
                                <Link to={`/${window.localStorage.getItem('seller_slug')}/collections`}>products</Link>
                            </li>
                        </ul>
                    ) : (
                        <ul>
                            <li>
                                <Link to="/brands"> BRANDS A-Z</Link>
                            </li>
                            {this.state.segments.map((item, index) => {
                                return (
                                    this.props.handleClick === undefined ? (
                                        <li key={index}>
                                            <Link to={`/brands/?segments=${item.id}&title=${escape(item.name)}`}>{item.name} </Link>
                                        </li>
                                    ) : (
                                        <li onClick={(ev) => this.handleClick(`?segments=${item.id}`, ev)} key={index}>
                                            <Link to={`/brands/?segments=${item.id}&title=${escape(item.name)}`}>{item.name} </Link>
                                        </li>
                                    )

                                )
                            })}
                        </ul>
                    )}
                    {MenuComponent.isLogged() ? (
                        <div id="LoginMobile">
                            <p onClick={() => this.showLightBox()}>sign in</p>
                            {this.state.showLightBox &&
                            <RenderLightBox show={this.state.showLightBox} handleClick={() => this.closeLightBox()}/>
                            }
                        </div>
                    ) : (
                        <div id="LoginMobile">
                            <Link to="/">Hello, {window.localStorage.getItem("user")} </Link>
                            <p><span onClick={() => AuthenticationService.logout()}> Logout </span></p>
                        </div>
                    )}
                    <SearchComponent/>
                </div>
            </nav>
        );
    }
}

export default MenuComponent;
